import { useSelector } from "react-redux";
import { Typography } from "@mui/material";
import { ConversationInfo, ConversationMessage } from "../../../redux/conversation/conversationSlice";
import React from "react";
import { MessageType } from "../../../redux/conversation/messageListSlice";
import { MessageTileSystem } from "./MessageTileSystem";
import { selectUser } from "../../../redux/user/userSlice";
import { MessageTileMyself } from "./MessageTileMyself";
import { MessageTileOther } from "./MessageTileOther";
import { MessagePriority } from "../../../redux/conversation/messagePriority";

interface MessageTileProps {
    conversation: ConversationInfo;
    message: ConversationMessage;
    content?: React.ReactNode;
}

export const MessageTile = (props: MessageTileProps) => {
    const msg = props.message;
    const user = useSelector(selectUser);

    switch (msg.messageType) {
        case MessageType.PARTY_JOINED:
        case MessageType.PARTY_LEFT:
        case MessageType.USER_JOINED:
        case MessageType.USER_LEFT:
        case MessageType.SURVEY_ANSWER:
        case MessageType.MESSAGE_DISMISSED:
        case MessageType.DELETE:
        case MessageType.CHANGED:
            return <MessageTileSystem conversation={props.conversation} message={msg}/>;
        case MessageType.TEXT:
        case MessageType.PDF:
        case MessageType.FILE:
        case MessageType.IMAGE:
        case MessageType.SURVEY:
            if (msg.userId == user.priza.info?.id && msg.messagePriority == MessagePriority.Regular) {
                return <MessageTileMyself message={msg} content={props.content} />;
            } else {
                return <MessageTileOther conversation={props.conversation} message={msg} content={props.content} />;
            }
        default:
            return <Typography variant="body2" sx={{ color: "text.secondary" }}>
                {`Tipo de mensagem não tratada #${props.message.messageType}`}
            </Typography>;
    }

};